import { useTanstack } from "../../hooks";
import { AuthServicesCacheEnum } from "./auth.props";
import AuthServices from "./auth.service";

const AuthServicesCache = () => {
  const { getExampleService } = AuthServices();

  const getExampleCache = useTanstack({
    queryKey: [AuthServicesCacheEnum.AUTH_EXAMPLE],
    queryFn: getExampleService,
  });

  return {
    getExampleCache,
  };
};

export default AuthServicesCache;
